export const deriveSubscriptionView = (currentSubscription) => {
  const currentPlanId = currentSubscription?.plan_id || 'free';
  const currentPeriodEnd = currentSubscription?.current_period_end || null;
  const autoRenew = !Boolean(currentSubscription?.cancel_at_period_end);
  return { currentPlanId, currentPeriodEnd, autoRenew };
};
